var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 216,
    viewBox: "0 0 230 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2192_1962)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.053,
    cy: 107.769,
    rx: 74.9351,
    ry: 74.8453,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "0.01 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.403 114.839C39.2737 113.956 39.1857 113.062 39.1857 112.143C39.1857 102.171 47.0792 94.0841 56.8303 94.0391C55.5949 76.0481 60.9772 64.4248 62.7126 61.1735C64.4943 57.8361 84.2426 29.3153 114.979 34.9284C142.384 39.9335 157.029 71.6912 159.883 78.5189C163.871 76.5566 168.341 75.457 173.062 75.457C189.848 75.457 203.458 89.3604 203.458 106.512C203.458 109.389 203.066 112.172 202.348 114.818C211.13 115.896 217.94 123.52 217.94 132.783C217.94 142.395 210.604 150.237 201.342 150.832V150.89H41.8976V150.878C41.8193 150.879 41.7419 150.89 41.6636 150.89C31.8757 150.89 23.9395 142.783 23.9395 132.783C23.9395 123.566 30.6854 115.975 39.403 114.839Z",
    fill: "#25272A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.052,
    cy: 107.77,
    rx: 106.442,
    ry: 106.314,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "0.01 4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.092,
    cy: 90.9178,
    rx: 21.416,
    ry: 21.3904,
    stroke: "#F74848",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeDasharray: "0.01 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.394 47.4497C227.394 49.656 225.605 51.4446 223.399 51.4446C221.192 51.4446 219.404 49.656 219.404 47.4497C219.404 45.2431 221.192 43.4545 223.399 43.4545C225.605 43.4545 227.394 45.2431 227.394 47.4497Z",
    fill: "#EA5A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.97 173.401C199.97 175.607 198.141 177.396 195.884 177.396C193.628 177.396 191.799 175.607 191.799 173.401C191.799 171.194 193.628 169.406 195.884 169.406C198.141 169.406 199.97 171.194 199.97 173.401Z",
    fill: "#E69F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.688 22.5234C82.688 24.7299 80.859 26.5186 78.6027 26.5186C76.3465 26.5186 74.5175 24.7299 74.5175 22.5234C74.5175 20.317 76.3465 18.5283 78.6027 18.5283C80.859 18.5283 82.688 20.317 82.688 22.5234Z",
    fill: "#02B1AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17056 122.946C8.17056 125.152 6.34154 126.941 4.08528 126.941C1.82904 126.941 0 125.152 0 122.946C0 120.74 1.82904 118.951 4.08528 118.951C6.34154 118.951 8.17056 120.74 8.17056 122.946Z",
    fill: "#5657D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8901 124.16L128.328 114.436L137.646 148.396C137.646 148.396 138.079 156.037 121.966 160.004C105.854 163.971 102.209 158.12 102.209 158.12L92.8901 124.16Z",
    fill: "url(#paint0_linear_2192_1962)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.491 114.801C129.528 118.673 122.42 123.94 112.615 126.566C102.81 129.192 94.0215 128.182 92.9847 124.31C91.9475 120.438 99.0555 115.171 108.861 112.545C118.665 109.919 127.454 110.929 128.491 114.801Z",
    fill: "#E43F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.877 52.5334L83.7285 50.6587L89.9294 75.0294L121.366 76.4715L114.877 52.5334Z",
    fill: "#F74848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7881 97.8487L89.9433 74.9032L121.3 76.4483L112.374 99.2222L80.7881 97.8487Z",
    fill: "#AD2625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9128 74.9523L83.7462 50.6406L74.8776 74.1404L80.7935 97.8623L89.9128 74.9523Z",
    fill: "#FF7676"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2192_1962",
    x1: 127.11,
    y1: 120.556,
    x2: 99.1529,
    y2: 152.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C52F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#370B09"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2192_1962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 230,
    height: 215.607,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/NotFound.d59af096e5eedef8ce272efaba44021a.svg";
export { ForwardRef as ReactComponent };